import { gql } from '@apollo/client';

export const GET_COMPANY_CHATS = gql`
  query GetCompanyChats {
    getCompanyChats {
      id
      createdAt
      updatedAt
      title
      companyId
      messages {
        id
        createdAt
        content
        sender {
          id
          firstName
          lastName
          email
          role
        }
      }
    }
  }
`;

export const GET_COMPANY_CHAT = gql`
  query GetCompanyChat($chatId: String!, $limit: Int, $offset: Int) {
    getCompanyChat(chatId: $chatId, limit: $limit, offset: $offset) {
      id
      createdAt
      updatedAt
      title
      companyId
      company {
        id
        name
      }
      messages {
        id
        createdAt
        content
        senderId
        sender {
          id
          firstName
          lastName
          email
          role
        }
      }
    }
  }
`;

export const CREATE_COMPANY_CHAT = gql`
  mutation CreateCompanyChat($title: String) {
    createCompanyChat(title: $title) {
      id
      createdAt
      title
      companyId
    }
  }
`;

export const SEND_COMPANY_CHAT_MESSAGE = gql`
  mutation SendCompanyChatMessage($chatId: String!, $content: String!) {
    sendCompanyChatMessage(chatId: $chatId, content: $content) {
      id
      createdAt
      content
      senderId
      sender {
        id
        firstName
        lastName
        email
        role
      }
    }
  }
`;
